import { Controller } from "@hotwired/stimulus";

// WORKAROUND: Native HTML <dialog> element intercepts Enter key and closes the dialog
// instead of submitting the form. This controller prevents that behavior.
// See: https://github.com/whatwg/html/issues/2588
export default class extends Controller {
  connect() {
    this.handleKeydown = (event) => {
      if (event.key !== "Enter" || event.shiftKey) return;

      const target = event.target;
      if (!target.matches("input, textarea, select")) return;
      if (!this.element.contains(target)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      this.element.requestSubmit();
    };

    this.element.addEventListener("keydown", this.handleKeydown);
  }

  disconnect() {
    this.element.removeEventListener("keydown", this.handleKeydown);
  }
}
